import { z } from 'zod';
const isNullableRequiredNumberInRange = (value, min, max) => (min === undefined || value >= min) && (max === undefined || value <= max);
export const nullableRequiredNumber = (options) => {
    const { requiredMessage, min, max } = options;
    const hasRange = min !== undefined || max !== undefined;
    const requiredSchema = z
        .number()
        .nullable()
        .refine((value) => value !== null, { message: requiredMessage });
    const schema = hasRange
        ? requiredSchema.refine((value) => value === null || isNullableRequiredNumberInRange(value, min, max), {
            message: options.rangeMessage,
        })
        : requiredSchema;
    return schema.transform((value) => value);
};
